import CryptoJS from 'crypto-js'

export const crypted = (word) => {
  word = CryptoJS.enc.Hex.parse(word)
  word = CryptoJS.enc.Base64.stringify(word)
  var key = CryptoJS.enc.Utf8.parse('Fwqx@08181452014')
  var decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })

  return CryptoJS.enc.Utf8.stringify(decrypt).toString()
}

// 加密
export const encrypt = (word, keyStr) => {
  keyStr = keyStr || 'Fwqx@08181452014'
  const key = CryptoJS.enc.Utf8.parse(keyStr)
  const srcs = CryptoJS.enc.Utf8.parse(word)
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}
